import React, {useEffect, useState} from 'react';
import {getContentApprovalWithSignature} from "../../api/approval/ContentApprovalService";
import {ApprovalType, ContentStatus} from "../../constant/CodeSpecNum";
import {useSelector} from "react-redux";

const IMG_BASE = import.meta.env.VITE_IMG_BASE;

function SignAxisLabel({children}) {
    return <div className="sign-container__axis-label sign-border">{children}</div>;
}

function SignSlot({label, signaturePath}) {
    return (
        <div className="sign-container__slot">
            <div className="sign-container__signature-box sign-border">
                {signaturePath && <img src={IMG_BASE + signaturePath} alt="" />}
            </div>
            <p className="sign-container__name sign-border">{label}</p>
        </div>
    );
}

function SignContainer({contentId, contentCategory, statusNumericValue}) {
    const [contentApproval, setContentApproval] = useState({});
    const [afterContentApproval, setAfterContentApproval] = useState({});
    const approvalStatus = useSelector(state => state.content.contentApproval);

    useEffect(() => {
        const fetchData = async () => {
            if (contentId) {
                const response = await getContentApprovalWithSignature({contentId, contentCategory});
                if (response && response.status === 200) {
                    setContentApproval(response.data.pre);
                    setAfterContentApproval(response.data.post);
                }
            }
        };

        fetchData();
    }, [contentId, contentCategory, approvalStatus]);

    const hasPre = Array.isArray(contentApproval) && contentApproval.length > 0;
    const hasPost = Array.isArray(afterContentApproval) && afterContentApproval.length > 0;

    if (!hasPre && !hasPost) {
        return null;
    }

    if (hasPre && contentApproval[0].approvalType === ApprovalType.PENDING) {
        return null;
    }

    const preFirst = hasPre ? contentApproval[0] : null;
    const showPreLine = preFirst?.approvalType !== ApprovalType.APPROVAL_PASSED;
    const showPrePassedOnly = preFirst?.approvalType === ApprovalType.APPROVAL_PASSED;
    const rejectedPre = contentApproval?.filter(user => user.approvalType === ApprovalType.REJECTED) ?? [];
    const showPostLine = afterContentApproval?.length > 0
        && ContentStatus.VERIFICATION.statusNumericValue < statusNumericValue;

    return (
        <div className="sign-container">
            {showPrePassedOnly && <SignSlot label="전결" />}

            {showPreLine && (
                <div className="sign-container__group">
                    <SignAxisLabel>결재</SignAxisLabel>
                    {contentApproval.map((user, key) => {
                        if (user.approvalType === ApprovalType.APPROVED) {
                            return (
                                <SignSlot
                                    key={key}
                                    label={user.approvedUserName}
                                    signaturePath={user.signaturePath}
                                />
                            );
                        }
                        if (user.approvalType === ApprovalType.HAS_NO_APPROVERS) {
                            return <SignSlot key={key} label="전결" />;
                        }
                        return null;
                    })}
                </div>
            )}

            {rejectedPre.map((user, key) => (
                <div key={key} className="sign-container__group">
                    <SignAxisLabel>반려</SignAxisLabel>
                    <SignSlot label={user.approvedUserName} signaturePath={user.signaturePath} />
                </div>
            ))}

            {showPostLine && (
                <div className="sign-container__group">
                    {afterContentApproval[0]?.approvalType === ApprovalType.APPROVAL_PASSED && (
                        <SignSlot label="사후전결" />
                    )}
                    <SignAxisLabel>사후결재</SignAxisLabel>
                    {afterContentApproval.map((user, key) => {
                        if (user.approvalType === ApprovalType.APPROVED) {
                            return (
                                <SignSlot
                                    key={key}
                                    label={user.approvedUserName}
                                    signaturePath={user.signaturePath}
                                />
                            );
                        }
                        if (user.approvalType === ApprovalType.HAS_NO_APPROVERS) {
                            return <SignSlot key={key} label="전결" />;
                        }
                        return null;
                    })}
                    {afterContentApproval.map((user, key) => (
                        user.approvalType === ApprovalType.REJECTED ? (
                            <React.Fragment key={`post-reject-${key}`}>
                                <SignAxisLabel>사후반려</SignAxisLabel>
                                <SignSlot label={user.approvedUserName} signaturePath={user.signaturePath} />
                            </React.Fragment>
                        ) : null
                    ))}
                </div>
            )}
        </div>
    );
}

export default SignContainer;
